import React from "react";
import ListIcon from "@mui/icons-material/List";
import ListBrowser, { CollectionType, getListBrowserStore } from "@ts-private/list-browser";
import { useApolloFetching } from "@ts-private/list-browser-apollo-extensions";
import { Card } from "@totalsoft/rocket-ui";
import ListItem from "./ListItem";
import { PARTNER_LIST_QUERY, PARTNER_TYPES_QUERY } from "../queries";
import { useListBrowserFunctions } from "hooks/useListBrowserFunctions";

const partnerListStore = getListBrowserStore({
  name: "partners-browser",
  filterDefinitions: [
    {
      name: "partnerName",
      caption: "Partner.Name",
      type: "text"
    },
    {
      name: "uniqueId",
      caption: "Partner.UniqueID",
      type: "text"
    },
    {
      name: "partnerTypeId",
      caption: "Partner.Type",
      type: "select",
      underlyingType: "number"
    }
  ],
  orderByFields: [
    {
      caption: "Partner.UniqueID",
      value: "UniqueId"
    },
    {
      caption: "Partner.Name",
      value: "PartnerName"
    }
  ],
  pager: {
    orderBy: "PartnerName",
    direction: "asc"
  }
});

const partnerListFetchingOptions = {
  queryOptions: { query: PARTNER_LIST_QUERY, name: "partners", fetchPolicy: "network-only" },
  collectionsOptions: [
    {
      queryOptions: { query: PARTNER_TYPES_QUERY },
      name: "partnerTypes",
      identifier: "partnerTypeId",
      collectionType: CollectionType.Filter,
      valueKey: "partnerTypeId",
      labelKey: "partnerTypeName"
    }
  ]
};

const PartnerListBrowser = () => {
  useApolloFetching(partnerListStore, partnerListFetchingOptions);
  const { textResolver } = useListBrowserFunctions();

  return (
    <Card icon={ListIcon}>
      <ListBrowser store={partnerListStore} ItemComponent={ListItem} textResolver={textResolver} />
    </Card>
  );
};

export default PartnerListBrowser;
